import React from 'react';
import './NavBar.css';
import { Nav, Navbar } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NavBar = () => {
  return (
    <>
      <Navbar
        fixed="top"
        className="navbar-custom "
        bg="dark"
        expand="lg">
        <Navbar.Brand as={Link} to="/">
          <h3 className="pl-5 custom-brand">
            Reya
            </h3>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto mr-5">
            <Nav.Link
              className="mr-3"
              href="#homePage">
              Home
              </Nav.Link>
            <Nav.Link
              className="mr-3"
              href="#aboutPage">
              About
              </Nav.Link>
            <Nav.Link
              className="mr-3"
              href="#projectsPage">
              Projects
              </Nav.Link>
            <Nav.Link
              className="mr-3"
              href="#blogsPage">
              Blogs
              </Nav.Link>
            <Nav.Link
              className="mr-3"
              href="#contactPage">
              Contact
              </Nav.Link>

          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
};

export default NavBar;